module.exports = __webpack_public_path__ + "img/chat-fill.d8580d32.svg";